import { EServiceCode } from "@core-constants/product-service.const";
import { IShoppingCartIndividualStoredSuggestionPlus } from "@core-models/purchase-suggestion.model";
import { IItemProductLite } from "@core-models/shopping-cart-plus.model";
import { ERateSource } from "@core-constants/shopping-cart.const";
import { TokenManager } from "@core-managers/token.manager";


export abstract class ShoppingCartSuggestionItemBase
{
    private _parentId: number;
    private _suggestion: IShoppingCartIndividualStoredSuggestionPlus = undefined;
    private _itemProduct: IItemProductLite;
    private _isAkkyPro: boolean = false;

    public isAdded: boolean = false;
    public addedIsChanging: boolean = false;

  constructor(
    protected tokenManager: TokenManager) { }

    protected get suggestion(): IShoppingCartIndividualStoredSuggestionPlus
    {
        return this._suggestion;
    }

    protected set suggestion(value: IShoppingCartIndividualStoredSuggestionPlus)
    {
        if (!value)
        {
            this._suggestion = undefined;
            return;
        }

        this.isAdded = value.individualFeatures.isAdded;
        this._suggestion = value;
    }

    public get suggestionId (): string
    {
        return this.suggestion.suggestionId;
    }

    public get buttonId(): string
    {
        const itemData = `${this.suggestion.id}-${this._parentId}`;
        return `individual-suggestion-${itemData}`;
    }

    public get parentId(): number
    {
        return this._parentId;
    }

    public set parentId(value: number)
    {
        this._parentId = value;
  }

    public get label(): string
    {
      return this.suggestion.effectiveCoverages.find(x => x.id === this.suggestion.coverageId)?.rate?.source === ERateSource.AkkyPro
        ? this.suggestion.effectiveCoverages.find(x => x.id === this.suggestion.coverageId)!.rate?.message
        : this.suggestion.translations.textLabel;
    }

    public get bgLabel(): string
    {
      return this.suggestion.effectiveCoverages.find(x => x.id === this.suggestion.coverageId)?.rate?.source === ERateSource.AkkyPro ? 'bg-blue white' : 'bg-aqua white';
    }

    public isAkkyProUser(): boolean
    {
      return this.tokenManager.isAkkyProUser;
    }

    public get title(): string
    {
        return this.suggestion.individualFeatures.displayName ?? this.suggestion.translations.title;
    }

    public get subtitle(): string
    {
        return this.suggestion.translations.subtitle;
    }

    public get finalAmount(): number
    {
        const rate = this.suggestion.effectiveCoverages.length > 0 ? this.suggestion.effectiveCoverages.find(x => x.id === this.suggestion.coverageId)?.rate?.finalAmount : undefined;
        return rate || 0;
    }

    public get toggleTitle(): string
    {
        return this.isAdded === true ? "Eliminar" : "Agregar a carrito";
    }

    public get isDomain(): boolean
    {
        return this.suggestion.serviceToOffer.includes(EServiceCode.DOT);
    }

    public get itemProduct(): IItemProductLite
    {
        return this._itemProduct;
    }

    public set itemProduct(value: IItemProductLite)
    {
        if (!value)
        {
            this._itemProduct = undefined;
            return;
        }
        this._itemProduct = value;
    }

    public get isAkkyPro(): boolean
    {
        return this._isAkkyPro;
    }
    
    public set isAkkyPro(value: boolean)
    {
        this._isAkkyPro = value;
    }

    public get isUpgradeSuggestion(): boolean
    {
        return this.suggestion.individualFeatures.isValidUpgrade;
    }
}
